import React, { useState, useEffect } from "react";

const SortAndPagination = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  total,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  // Mobile View Component - Only shows listing count, no sort controls
  const MobileView = () => null;

  // Desktop View Component - Only shows listing count
  const DesktopView = () => null;

  return isMobile ? <MobileView /> : <DesktopView />;
};

export default SortAndPagination;
